import Glide, {
  Autoplay,
  Breakpoints,
} from '@glidejs/glide/dist/glide.modular.esm'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.core.scss'; // tslint:disable-line
import '@glidejs/glide/src/assets/sass/glide.theme.scss'; // tslint:disable-line

import './usp.pcss';

const opts = {
  glideSelector: '.glide-usp',
};

export class Usp {
  glide: Glide;

  constructor() {
    this.glide = new Glide(opts.glideSelector, {
      autoplay: 8000,
      bound: true,
      classes: {
        activeSlide: 'usp__slide--active',
      },
      perView: 1,
      type: 'slider',
    }).mount({
      Autoplay,
      Breakpoints,
    });
  }

  destroy() {
    this.glide.destroy();
  }
}
